// Types
import type { IIBatchesProps } from "./types";

export function Batches({REP_BUILD_DATA,infocusID,batches}: IIBatchesProps) {

    return (
        <div data-infocusID={infocusID === 9}
            className="md:absolute
                print:!relative
                print:!left-0
                border-[1px] border-r-[#000]
                last-of-type:border-none
                opacity-100 -left-[100%]
                data-[inFocusID=true]:opacity-0
                data-[inFocusID=true]:left-0
                transition-all duration-[0.38s]
                w-full h-screen flex flex-col justify-between gap-4 p-16 bg-white
                page-break
            "
        >
            <div className="w-[60%] flex flex-col justify-between gap-16 py-16">
                <span className="w-full h-auto flex flex-col gap-4">
                    <span className="text-5xl">Lotes disponíveis até {REP_BUILD_DATA?.idealArea || 0}m² </span>
                </span>
            </div>
            <span className="w-full flex-1 flex flex-col gap-0">
                <span className="w-full h-12 flex flex-row flex-nowrap items-center justify-center">
                    <span className="flex flex-nowrap items-center justify-center p-6 bg-[#cde9e1] flex-1 font-semibold first-of-type:border-l-[2px]">Módulo</span>
                    <span className="flex flex-nowrap items-center justify-center p-6 bg-[#cde9e1] flex-1 font-semibold">Quadra/Lote</span>
                    <span className="flex flex-nowrap items-center justify-center p-6 bg-[#cde9e1] flex-1 font-semibold">Área (m²)</span>
                    <span className="flex flex-nowrap items-center justify-center p-6 bg-[#cde9e1] flex-1 font-semibold">Valor total</span>
                    <span className="flex flex-nowrap items-center justify-center p-6 bg-[#cde9e1] flex-1 font-semibold">R$/m²</span>
                    <span className="flex flex-nowrap items-center justify-center p-6 bg-[#cde9e1] flex-1 font-semibold">Frente(m)</span>
                    <span className="flex flex-nowrap items-center justify-center p-6 bg-[#cde9e1] flex-1 font-semibold">Lateral(m)</span>
                    <span className="flex flex-nowrap items-center justify-center p-6 bg-[#cde9e1] flex-1 font-semibold">Fundo(m)</span>
                </span>
                <span className="w-full flex-1 flex flex-col mt-2">
                    {
                        batches.map(batche => (
                            <span
                                key={batche.id}
                                data-idealbatch={batche.area <= (REP_BUILD_DATA?.idealArea || 0)}
                                className="w-full h-auto
                                    flex flex-row
                                    flex-nowrap
                                    border-[2px]
                                    border-black
                                    data-[idealbatch=true]:bg-[#9cd3c3]
                                    hover:bg-[#9cd3c3]

                                "
                            >
                                <span className="max-w-[50%] z-[999] flex flex-nowrap items-center justify-center p-6 flex-1 font-semibold first-of-type:border-r-[2px]  border-black">
                                    {
                                        batche.name
                                    }
                                </span>
                                <span className="max-w-[50%] flex flex-nowrap items-center justify-center p-6 flex-1 font-semibold border-r-[2px] last-of-type:border-none  border-black">
                                    {
                                        batche.batch
                                    }
                                </span>
                                <span className="max-w-[50%] flex flex-nowrap items-center justify-center p-6 flex-1 font-semibold border-r-[2px] last-of-type:border-none  border-black">
                                    {
                                        batche.area
                                    }m²
                                </span>
                                <span className="max-w-[50%] flex flex-nowrap items-center justify-center p-6 flex-1 font-semibold border-r-[2px] last-of-type:border-none  border-black">
                                    {
                                        Intl.NumberFormat("pt-BR", {
                                            style: 'currency',
                                            currency: 'BRL'
                                        }).format(batche.amount)
                                    }
                                </span>
                                <span className="max-w-[50%] flex flex-nowrap items-center justify-center p-6 flex-1 font-semibold border-r-[2px] last-of-type:border-none  border-black">
                                    {
                                        Intl.NumberFormat("pt-BR", {
                                            style: 'currency',
                                            currency: 'BRL'
                                        }).format(batche.square_meter)
                                    }/m²
                                </span>
                                <span className="max-w-[50%] flex flex-nowrap items-center justify-center p-6 flex-1 font-semibold border-r-[2px] last-of-type:border-none  border-black">
                                    {
                                        batche.front
                                    }m²
                                </span>
                                <span className="max-w-[50%] flex flex-nowrap items-center justify-center p-6 flex-1 font-semibold border-r-[2px] last-of-type:border-none  border-black">
                                    {
                                        batche.side
                                    }m²
                                </span>
                                <span className="max-w-[50%] z-[999] flex flex-nowrap items-center justify-center p-6 flex-1 font-semibold border-r-[2px] last-of-type:border-none  border-black">
                                    {
                                        batche.bottom
                                    }m²
                                </span>
                            </span>
                        ))
                    }
                </span>
            </span>
        </div>
    )
}
